import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PgUiControlsModule } from '../pg-ui-controls/pg-ui-controls.module';
import { PgUiElementsModule } from '../pg-ui-elements/pg-ui-elements.module';
import { PgLoginHandlerComponent } from './pg-login-handler/pg-login-handler.component';
import { PgHelpModule } from '../pg-help/pg-help.module';
import { PgAvailabilitySelectComponent } from './pg-availability-select/pg-availability-select.component';
import { PgChatModule } from '../pg-chat/pg-chat.module';
import { PgAcceptConditionsComponent } from './pg-accept-conditions/pg-accept-conditions.component';
import { PgNotificationListComponent } from './pg-notification-list/pg-notification-list.component';
import { PgChangePasswordComponent } from './pg-change-password/pg-change-password.component';
import { PgProfileEditorComponent } from './pg-profile-editor/pg-profile-editor.component';
import { PgEditProfileComponent } from './pg-edit-profile/pg-edit-profile.component';
import { PgLoginHandlerDefaultComponent } from './pg-login-handler/pg-login-handler-default/pg-login-handler-default.component';
import { PgLoginHandlerOtpComponent } from './pg-login-handler/pg-login-handler-otp/pg-login-handler-otp.component';
import { PgLoginHandlerCodeComponent } from './pg-login-handler/pg-login-handler-code/pg-login-handler-code.component';
import { PgCompleteProfileComponent } from './pg-complete-profile/pg-complete-profile.component';

@NgModule({
    declarations: [
        PgLoginHandlerComponent,
        PgLoginHandlerDefaultComponent,
        PgLoginHandlerOtpComponent,
        PgLoginHandlerCodeComponent,
        PgCompleteProfileComponent,
        PgChangePasswordComponent,
        PgAvailabilitySelectComponent,
        PgAcceptConditionsComponent,
        PgNotificationListComponent,
        PgProfileEditorComponent,
        PgEditProfileComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        PgUiControlsModule,
        PgUiElementsModule,
        PgHelpModule,
        PgChatModule
    ],
    exports: [
        PgLoginHandlerComponent,
        PgCompleteProfileComponent,
        PgAvailabilitySelectComponent,
        PgAcceptConditionsComponent,
        PgNotificationListComponent,
        PgProfileEditorComponent
    ]
})
export class PgUiMoleculesModule { }
